function getDateHour(dt = new Date()) {
  return (
    ((dt.getHours() % 12 || 12) < 10 ? "0" : "") + (dt.getHours() % 12 || 12)
  );
}

function getDateMinutes(dt = new Date()) {
  return (dt.getMinutes() < 10 ? "0" : "") + dt.getMinutes();
}

function getDateAMPM(dt = new Date()) {
  return dt.getHours() >= 12 ? "PM" : "AM";
}

export { getDateHour, getDateMinutes, getDateAMPM };
